import { render, staticRenderFns } from "./PorPlanoButaca.vue?vue&type=template&id=70192ac9"
import script from "./PorPlanoButaca.vue?vue&type=script&lang=js"
export * from "./PorPlanoButaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports